// @warp-css;
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { classNames } from '@chbphone55/classnames';
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { reset } from '../styles';
import { styles } from './styles';
/**
 * `w-badge` is used for showing a small amount of non-interactive color-categorized metadata, like a status or count.
 *
 * [See Storybook for usage examples](https://warp-ds.github.io/elements/?path=/docs/layout-badge--docs)
 */
class WarpBadge extends LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'neutral';
    }
    static { this.styles = [reset, styles]; }
    /** @internal */
    get _class() {
        return classNames([
            'py-4 px-8 border-0 rounded-4 text-xs inline-flex',
            this.variant === 'neutral' && 'bg-[--w-color-badge-neutral-background] s-text',
            this.variant === 'info' && 'bg-[--w-color-badge-info-background] s-text',
            this.variant === 'positive' && 'bg-[--w-color-badge-positive-background] s-text',
            this.variant === 'warning' && 'bg-[--w-color-badge-warning-background] s-text',
            this.variant === 'negative' && 'bg-[--w-color-badge-negative-background] s-text',
            this.variant === 'disabled' && 's-bg-disabled s-text',
            this.variant === 'price' && 'bg-[--w-black/70] s-text-inverted-static',
            this.variant === 'sponsored' && 'bg-[--w-color-badge-sponsored-background] s-text',
            !!this.position && 'absolute backdrop-blur',
            this.position === 'top-left' && 'rounded-tl-0 rounded-tr-0 rounded-bl-0 top-0 left-0',
            this.position === 'top-right' && 'rounded-tl-0 rounded-tr-0 rounded-br-0 top-0 right-0',
            this.position === 'bottom-right' && 'rounded-tr-0 rounded-br-0 rounded-bl-0 bottom-0 right-0',
            this.position === 'bottom-left' && 'rounded-tl-0 rounded-br-0 rounded-bl-0 bottom-0 left-0',
        ]);
    }
    render() {
        return html `
      <div class="${this._class}">
        <slot></slot>
      </div>
    `;
    }
}
__decorate([
    property({ type: String, reflect: true })
], WarpBadge.prototype, "variant", void 0);
__decorate([
    property({ type: String, reflect: true })
], WarpBadge.prototype, "position", void 0);
if (!customElements.get('w-badge')) {
    customElements.define('w-badge', WarpBadge);
}
export { WarpBadge };
//# sourceMappingURL=badge.js.map